import React, { createContext, useContext, useEffect } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

// MELLETIC is a light-only experience. Theme is fixed to "light".
export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "light");
  }, []);

  const noop = () => {};
  return (
    <ThemeContext.Provider value={{ theme: "light", setTheme: noop, toggle: noop }}>
      {children}
    </ThemeContext.Provider>
  );
}
